<template>
  <div class="compare-page">
    <div class="top-bar">
      <el-button icon="el-icon-arrow-left" size="small" @click="goBack">返回</el-button>
      <span class="compare-title">同屏对比</span>
    </div>
    <div class="compare-body">
      <!-- 左侧 -->
      <div class="compare-side">
        <div class="side-header">
          <el-select v-model="leftStageId" size="small" style="width: 260px;" @change="loadLeftDetail">
            <el-option v-for="item in stageList" :key="item.id" :label="item.label" :value="item.id" />
          </el-select>
        </div>
        <div class="side-stats">
          <div class="stat-row">
            <span class="stat-label">植被覆盖率</span>
            <span class="stat-value">{{ leftDetail.vegetationCoverage != null ? leftDetail.vegetationCoverage + '%' : '-' }}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">植被成活数</span>
            <span class="stat-value">{{ leftDetail.vegetationSurvivalRate != null ? leftDetail.vegetationSurvivalRate + '株' : '-' }}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">修复面积</span>
            <span class="stat-value">{{ leftDetail.repairArea != null ? leftDetail.repairArea + '㎡' : '-' }}</span>
          </div>
        </div>
        <div class="map-wrap">
          <swqyun-map
            ref="leftMap"
            style="width: 100%; height: 100%;"
            :scene-url="leftSceneUrl"
            :session-key="leftSessionKey"
            :app-id="leftAppId"
            :editable="false"
            :vectors="leftVectors"
            scene="spot"
            @camera-changed="onLeftCameraChanged"
          />
        </div>
        <div class="side-footer">
          <span v-if="leftDetail.createTime">{{ formatYearMonth(leftDetail.createTime) }}</span>
        </div>
      </div>

      <!-- 中线 -->
      <div class="compare-divider">
        <div class="mode-switch">
          <el-button :type="mapMode === '2d' ? 'primary' : 'default'" size="mini" @click="mapMode = '2d'">2D</el-button>
          <el-button :type="mapMode === '3d' ? 'primary' : 'default'" size="mini" @click="mapMode = '3d'">3D</el-button>
        </div>
      </div>

      <!-- 右侧 -->
      <div class="compare-side">
        <div class="side-header">
          <el-select v-model="rightStageId" size="small" style="width: 260px;" @change="loadRightDetail">
            <el-option v-for="item in stageList" :key="item.id" :label="item.label" :value="item.id" />
          </el-select>
        </div>
        <div class="side-stats">
          <div class="stat-row">
            <span class="stat-label">植被覆盖率</span>
            <span class="stat-value">{{ rightDetail.vegetationCoverage != null ? rightDetail.vegetationCoverage + '%' : '-' }}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">植被成活数</span>
            <span class="stat-value">{{ rightDetail.vegetationSurvivalRate != null ? rightDetail.vegetationSurvivalRate + '株' : '-' }}</span>
          </div>
          <div class="stat-row">
            <span class="stat-label">修复面积</span>
            <span class="stat-value">{{ rightDetail.repairArea != null ? rightDetail.repairArea + '㎡' : '-' }}</span>
          </div>
        </div>
        <div class="map-wrap">
          <swqyun-map
            ref="rightMap"
            style="width: 100%; height: 100%;"
            :scene-url="rightSceneUrl"
            :session-key="rightSessionKey"
            :app-id="rightAppId"
            :editable="false"
            :vectors="rightVectors"
            scene="spot"
            @camera-changed="onRightCameraChanged"
          />
        </div>
        <div class="side-footer" style="text-align: right;">
          <span v-if="rightDetail.createTime">{{ formatYearMonth(rightDetail.createTime) }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SwqyunMap from "@/components/SwqyunMap.vue";

export default {
  components: { SwqyunMap },
  data() {
    return {
      spotId: null,
      stageList: [],
      leftStageId: null,
      rightStageId: null,
      leftDetail: {},
      rightDetail: {},
      leftVectors: [],
      rightVectors: [],
      mapMode: "2d",
      isSyncing: false,
      sceneUrl: "",
      sessionKey: "",
      appId: ""
    };
  },
  computed: {
    leftSceneUrl() {
      return this.mapMode === "3d" && this.leftDetail.map3dSceneUrl ? this.leftDetail.map3dSceneUrl : (this.leftDetail.map2dSceneUrl || this.sceneUrl);
    },
    leftSessionKey() {
      return this.mapMode === "3d" && this.leftDetail.map3dSessionKey ? this.leftDetail.map3dSessionKey : (this.leftDetail.map2dSessionKey || this.sessionKey);
    },
    leftAppId() {
      return this.mapMode === "3d" && this.leftDetail.map3dAppId ? this.leftDetail.map3dAppId : (this.leftDetail.map2dAppId || this.appId);
    },
    rightSceneUrl() {
      return this.mapMode === "3d" && this.rightDetail.map3dSceneUrl ? this.rightDetail.map3dSceneUrl : (this.rightDetail.map2dSceneUrl || this.sceneUrl);
    },
    rightSessionKey() {
      return this.mapMode === "3d" && this.rightDetail.map3dSessionKey ? this.rightDetail.map3dSessionKey : (this.rightDetail.map2dSessionKey || this.sessionKey);
    },
    rightAppId() {
      return this.mapMode === "3d" && this.rightDetail.map3dAppId ? this.rightDetail.map3dAppId : (this.rightDetail.map2dAppId || this.appId);
    }
  },
  created() {
    this.spotId = this.$route.query.spotId ? Number(this.$route.query.spotId) : null;
    this.loadMapConfig();
    this.loadStageList();
  },
  methods: {
    loadMapConfig() {
      const districtId = this.$store.state.district && this.$store.state.district.districtInfo && this.$store.state.district.districtInfo.districtId;
      this.$apis.get("/admin/districtMapConfig/detail", { districtId }).then(res => {
        if (res && res.data && res.data.code == 200 && res.data.data) {
          const cfg = res.data.data;
          this.sceneUrl = cfg.sceneUrl;
          this.sessionKey = cfg.sessionKey;
          this.appId = cfg.appId;
        } else {
          this.fallbackMap();
        }
      }).catch(() => this.fallbackMap());
    },
    fallbackMap() {
      this.sceneUrl = "https://api.swqyun.com/api/fileManage/Scene/SDKGetScene?id=138b92545134d878d5d90ca45490263c";
      this.sessionKey = "0271ae43f09e427cb6927d6255446bc0b3cec903f45b48a49fb22dba752f52cb";
      this.appId = "31f37381eb434c2b";
    },
    loadStageList() {
      if (!this.spotId) return;
      this.$apis.get("/admin/spot/stage/list", { spotId: this.spotId }).then(res => {
        if (res.data.code == 200) {
          this.stageList = res.data.data || [];
          if (this.stageList.length > 0) {
            // 左侧默认当年第1阶段
            const first = this.stageList[this.stageList.length - 1]; // list 是倒序
            this.leftStageId = first.id;
            this.loadLeftDetail();
            // 右侧默认当年最后阶段
            this.rightStageId = this.stageList[0].id;
            this.loadRightDetail();
          }
        }
      });
    },
    loadLeftDetail() {
      if (!this.leftStageId) return;
      this.$apis.get("/admin/spot/stage/detail", { stageId: this.leftStageId }).then(res => {
        if (res.data.code == 200 && res.data.data) {
          this.leftDetail = res.data.data;
          this.buildVectors("left");
        }
      });
    },
    loadRightDetail() {
      if (!this.rightStageId) return;
      this.$apis.get("/admin/spot/stage/detail", { stageId: this.rightStageId }).then(res => {
        if (res.data.code == 200 && res.data.data) {
          this.rightDetail = res.data.data;
          this.buildVectors("right");
        }
      });
    },
    buildVectors(side) {
      const detail = side === "left" ? this.leftDetail : this.rightDetail;
      const vectors = [];
      if (detail.vectorGeoJson) {
        try {
          const vec = JSON.parse(detail.vectorGeoJson);
          if (Array.isArray(vec)) {
            vectors.push(...vec);
          } else if (vec && vec.calcType && Array.isArray(vec.pointList)) {
            vectors.push(vec);
          }
        } catch (e) {}
      }
      const resources = detail.resources || [];
      resources.forEach(r => {
        if (r.longitude != null && r.latitude != null) {
          vectors.push({
            calcType: "point",
            pointList: [{ longitude: String(r.longitude), latitude: String(r.latitude), height: "0" }]
          });
        }
      });
      if (side === "left") this.leftVectors = vectors;
      else this.rightVectors = vectors;
    },
    formatYearMonth(timeStr) {
      if (!timeStr) return "";
      const d = new Date(timeStr);
      return d.getFullYear() + "年" + (d.getMonth() + 1) + "月";
    },
    onLeftCameraChanged(camera) {
      if (this.isSyncing) return;
      this.isSyncing = true;
      this.$refs.rightMap && this.$refs.rightMap.setCameraState(camera);
      setTimeout(() => { this.isSyncing = false; }, 200);
    },
    onRightCameraChanged(camera) {
      if (this.isSyncing) return;
      this.isSyncing = true;
      this.$refs.leftMap && this.$refs.leftMap.setCameraState(camera);
      setTimeout(() => { this.isSyncing = false; }, 200);
    },
    goBack() {
      this.$router.push({ path: "/spotDetail", query: { spotId: this.spotId } });
    }
  }
};
</script>

<style scoped>
.compare-page {
  position: relative;
  width: 100%;
  height: calc(100vh - 60px);
  background: #0a1a2e;
  display: flex;
  flex-direction: column;
}
.top-bar {
  height: 50px;
  background: rgba(10, 26, 46, 0.9);
  display: flex;
  align-items: center;
  padding: 0 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.compare-title {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  margin-left: 16px;
}
.compare-body {
  flex: 1;
  display: flex;
  position: relative;
  overflow: hidden;
}
.compare-side {
  flex: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}
.side-header {
  padding: 8px 12px;
  background: rgba(10, 26, 46, 0.8);
  z-index: 5;
}
.side-stats {
  display: flex;
  gap: 16px;
  padding: 6px 12px;
  background: rgba(10, 26, 46, 0.7);
  color: #fff;
  font-size: 12px;
  z-index: 5;
}
.stat-row {
  display: flex;
  align-items: center;
  gap: 4px;
}
.stat-label {
  color: #aaa;
}
.stat-value {
  color: #4fd1c5;
  font-weight: bold;
}
.map-wrap {
  flex: 1;
  position: relative;
}
.side-footer {
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  color: #fff;
  font-size: 12px;
  z-index: 5;
  text-shadow: 0 1px 2px rgba(0,0,0,0.5);
}
.compare-divider {
  width: 2px;
  background: rgba(255, 255, 255, 0.3);
  position: relative;
}
.mode-switch {
  position: absolute;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 4px;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/page/spotCompare.vue